import { isEmptyString } from './isEmptyString';

export const isValidNumber = (value: unknown): boolean => !isEmptyString(value) && !isNaN(value as number);
